import reduxConstants from "../../utils/redux/constant.js";

export const NUMBER_REGEX = /^\d+$/;
export const DATE_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;
export const CURRENCY_REGEX = /^\$\d+\.\d{2}$/;

export default reduxConstants("dataComponents", [
  "ADD_CURSOR",
  "CLEAR_CURSORS",
  "REGISTER",
  "RESET",
  "SET_CRUMB",
  "SET_CURSOR",
  "SET_FILTER",
  "SET_SORT_BY",
  "SET_SORT_DIRECTION",
  "UNREGISTER"
]);
